import React, { useContext, useEffect, useState } from "react";
import { Table, Button, TableProps } from "antd";
import {
  ReportSummaryRequest,
  AccountResponse,
} from "../../core/interfaces/reportSummaryRequest";
import { fetchReportSummary } from "../../core/services/report-summary-service";
import { useLocation, useNavigate } from "react-router-dom";
import ExcelJS from "exceljs";
import { appInsights } from "../../core/services/insight.service";
import GlobalErrorMessage from "../global-error/GlobalErrorMessage";
import "./reportSummary.css";



const ReportSummary: React.FC = () => {
  const [data, setData] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const location = useLocation();
  const [apiError, setApiError] = useState(null);
  const navigate = useNavigate();
  const fetchsummary = async () => {
   
    setLoading(true);
    let dat = location.state as ReportSummaryRequest;
    dat.Description = "";
    let responseData = await fetchReportSummary(dat);
   
   if (responseData ) {
    setData(responseData);
    console.log(data)

    

    }
    else{
      setApiError(responseData);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchsummary();
  }, []);

  const handleRequestIdClick = (requestID: string, status: number, type: string) => {
    const contextValue = {
      requestNumber: requestID,
      reqType: type === "ACCOUNT" ? "1" : "2",
      status: status.toString(),
      frompending: false,
    };
    navigate(`/manage requests/request-detail?requestNumber=${contextValue.requestNumber}&reqType=${contextValue.reqType}&frompending=${contextValue.frompending}&userEmail=null`);
  };

  const columns: TableProps<AccountResponse>["columns"] = [
    {
      title: "S/N",
      dataIndex: "sn",
      key: "sn",
      width: "15%",
      align: "right",
      render: (text: string, record: AccountResponse, index: number) =>
        `${index + 1}.`,
    },
    {
      title: "Request ID",
      dataIndex: "requestID",
      key: "requestID",
      width: "15%",
      render: (requestID: string, record: { status: number; type: string }) => (
        <Button
          type="link"
          onClick={() => handleRequestIdClick(requestID, record.status, record.type)}
          style={{
            padding: 0,
            color: "blue",
            textDecoration: "underline",
          }}
        >
          {requestID}
        </Button>
      ),
    },
    {
      title: "Action Type",
      dataIndex: "actioncode",
      key: "actioncode",
      width: "15%",
    },
    {
      title: "Business Unit",
      dataIndex: "costcenter",
      key: "costcenter",
      width: "15%",
    },
    {
      title: "Object",
      dataIndex: "object",
      key: "object",
      width: "15%",
    },
    {
      title: "Subsidiary",
      dataIndex: "subsidiary",
      key: "subsidiary",
      width: "20%",
    },
    {
      title: "Company",
      dataIndex: "company",
      key: "company",
      width: "15%",
    },
    {
      title: "Requested By",
      dataIndex: "requestby",
      key: "requestby",
      width: "20%",
    },
    {
      title: "Date of Request",
      dataIndex: "requestDate",
      key: "requestDate",
      width: "15%",
    },
    {
      title: "Comment",
      dataIndex: "comment",
      key: "comment",
      width: "20%",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      width: "20%",
    },
    {
      title: "Update Date",
      dataIndex: "updatedate",
      key: "updatedate",
      width: "15%",
    },
    {
      title: "Update By",
      dataIndex: "updateby",
      key: "updateby",
      width: "15%",
    },
  ];
  // Function to export data to Excel
  const exportToExcel = async () => {
    try {
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("ReportSummary");

      // Assuming 'data' is an array of objects
      worksheet.columns = Object.keys(data[0]).map((key) => ({
        header: key,
        key,
      }));

      data.forEach((item) => {
        worksheet.addRow(item);
      });

      // Generate a buffer instead of writing to file
      const buffer = await workbook.xlsx.writeBuffer();
      
      // Create a Blob from the buffer
      const blob = new Blob([buffer], { 
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
      });
      
      // Create download link and trigger download
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = "ReportSummary.xlsx";
      document.body.appendChild(a);
      a.click();
      
      // Clean up
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    } catch (error) {
      appInsights.trackEvent({
        name: "ExportToExcelFailed",
        properties: { error: error.message },
      });
    }
  };

  // Function to handle print
  const handlePrint = () => {
    const printContent = document.querySelector(".tbl-data");
    const printWindow = window.open("", "_blank");
    if (printWindow && printContent) {
      printWindow.document.write(`
        <html>
          <head>
            <title>Print Report Summary</title>
            <link rel="stylesheet" href="reportSummary.css" />
          </head>
          <body>
            ${printContent.outerHTML}
          </body>
        </html>
      `);
      printWindow.document.close();
      printWindow.print();
    }
  };

  const handleRetry = () => {
    setApiError(null);
    fetchsummary();
  };

  return (
    <>
      <div className="error-container">
        {apiError ? (
          <GlobalErrorMessage 
          error={apiError}
          visible={!!apiError}
          onClose={() => setApiError(null)}
          onRetry={handleRetry}
        />
        ) : <div className="div-container">
        <div className="tbl-data">
        <h3>Summary Report</h3>
        <Table
          dataSource={data}
          columns={columns}
          bordered
          pagination={false}
          //scroll={{ y: 200, x: 1500 }}
          loading={loading}
          className="white-cell-table"
          size="small"
        />
        <br />
        </div>
        <div id="divButtons" className="no-print">
          <Button type="primary" onClick={handlePrint}>
            Print
          </Button>
          <Button
            type="primary"
            style={{ marginLeft: 10 }}
            onClick={exportToExcel}
          >
            Send To Excel
          </Button>
          <Button
            onClick={() => window.history.back()}
            type="primary"
            style={{ marginLeft: 10 }}
          >
            Close
          </Button>
        </div>
      </div>}
      </div>
      
    </>
  );
};

export default ReportSummary;
